module.exports = __webpack_public_path__ + "img/scope4.07fc890f.png";